import CreateWebhookForm from './createMode';
import EditWebhookForm from './editMode';
import { BaseFormProps } from './types';

interface FormProps extends BaseFormProps {
    mode?: 'create' | 'edit';
}

const CreateEditWebhookForm = ({ mode = 'create', ...rest }: FormProps) => {
    if (mode === 'edit') {
        return <EditWebhookForm {...rest} />;
    }
    return <CreateWebhookForm {...rest} />;
};

export default CreateEditWebhookForm;
